import { ConnectionSource } from './types';

const connectionSources: Array<{ source: ConnectionSource; displayName: string }> = [
  {
    displayName: 'Plaid',
    source: ConnectionSource[ConnectionSource.PLAID],
  },
  {
    source: ConnectionSource[ConnectionSource.STRIPE],
    displayName: 'Stripe',
  },
  {
    source: ConnectionSource[ConnectionSource.SQUARE],
    displayName: 'Square',
  },
  {
    source: ConnectionSource[ConnectionSource.SHOPIFY],
    displayName: 'Shopify',
  },
  {
    displayName: 'Gusto',
    source: ConnectionSource[ConnectionSource.GUSTO],
  },
  {
    displayName: 'PayPal',
    source: ConnectionSource[ConnectionSource.PAYPAL],
  },
  {
    displayName: 'Amazon',
    source: ConnectionSource[ConnectionSource.AMAZON],
  },
];

export default connectionSources;
